// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active){  background: #E2E2E2 !important;}.v-tabs-slider-wrapper{  height: 0px !important;}.v-tab {    letter-spacing :0!important;\n}.v-tab--active{  font-weight: bolder !important;}", ""]);
// Exports
module.exports = exports;
